import { Component, OnInit } from '@angular/core';
import { MessageBusService, MicroFrontendRouter } from '@xdig/ng-microkernel/micro-frontend';
import { ModalService } from '../../modal.service';
import { ftdUrl } from '@core/layouts/default/default.config';

@Component({
  selector: 'shell-without-dpf',
  templateUrl: './without-dpf.component.html',
})
export class WithoutDpfComponent implements OnInit {
  constructor(
    private microFrontendRouter: MicroFrontendRouter,
    public modalService: ModalService,
    private messageBusService: MessageBusService,
  ) {}

  ngOnInit() {}

  closeModal() {
    this.messageBusService.emit('shell', 'footer.type', 'DEFAULT');
    window.location.href = window.location.origin + ftdUrl.firstPage;
    this.modalService.close();
    window.location.reload();
  }
}
